import { Box, Typography } from "@mui/material";

export default function SecondRow() {
  const leftBulletPoints = [
    "zarządzania gospodarką magazynową",
    "sprzedaży",
    "marketingu",
    "zarządzania serwisem.",
  ];
  const rightBulletPoints = [
    {
      text: "testy niefunkcjonalne:",
      sub: [
        "testy użyteczności",
        "testy kompatybilności",
        "testowanie interfejsów",
        "testowanie wydajności",
        "testowanie obciążenia",
        "testowanie przeciążenia",
      ],
    },
    {
      text: "testy funkcjonalne zgodności z wymaganiami i/lub najlepszymi praktykami",
    },
    { text: "testy bezpieczeństwa." },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        backgroundColor: "#FF7833",
        paddingTop: { xs: "0", md: "50px" },
      }}
    >
      {/* lewa kolumna (z tytulem, w nowym ukladzie ma to kopmonent Row)*/}

      {/* prawa kolumna */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          flex: { xs: "none", md: "1 1 auto" },
          p: { xs: 2, md: 4 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Właściwe wykorzystanie informatyki decyduje o sukcesie firmy. W dobie
          konkurencyjnej gospodarki niezwykle istotne jest dopasowanie
          oprogramowania do potrzeb biznesowych firmy.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              // lewy
              width: "45%",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Segoe UI",
                fontSize: { xs: "22px", md: "25px" },
                fontWeight: "bold",
                color: "#29235C",
                mb: 1,
              }}
            >
              Tworzymy dedykowane oprogramowanie, wspierające biznes w zakresie:
            </Typography>

            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              {leftBulletPoints.map((item, index) => (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    fontFamily: "Segoe UI",
                    fontSize: { xs: "18px", md: "20px" },
                    color: "#29235C",
                    mb: 0,
                    "&::marker": {
                      color: "#FF5700",
                    },
                  }}
                >
                  {item}
                </Box>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              // prawy
              width: "45%",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Segoe UI",
                fontSize: { xs: "22px", md: "25px" },
                fontWeight: "bold",
                color: "#29235C",
                mb: 1,
              }}
            >
              Wykonujemy następujące testy:
            </Typography>

            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              {rightBulletPoints.map((item, index) => (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    fontFamily: "Segoe UI",
                    fontSize: { xs: "18px", md: "20px" },
                    color: "#29235C",
                    mb: 1,
                    "&::marker": {
                      color: "#FF5700",
                    },
                  }}
                >
                  {item.text}

                  {item.sub && (
                    <Box
                      component="ul"
                      sx={{ pl: 3, mt: 1, listStyleType: "disc" }}
                    >
                      {item.sub.map((subItem, subIndex) => (
                        <Box
                          component="li"
                          key={subIndex}
                          sx={{
                            fontFamily: "Segoe UI",
                            fontSize: { xs: "16px", md: "18px" },
                            color: "#29235C",
                            mb: 0.5,
                            "&::marker": {
                              color: "#29235C",
                            },
                          }}
                        >
                          {subItem}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
